import React from "react";
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Icon, ListItem} from "semantic-ui-react";
import {connect} from "react-redux";
import {push} from 'connected-react-router/immutable'
import styled from 'styled-components';
import messages from "./messages";


class MenuList extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    onClickHandler(el, data) {
        const linkTo = data.value;
        if (linkTo) {
            window.scrollTo(0, 0);
            this.props.push(linkTo);
        }
    }

    render() {
        const MenuWrapper = styled.div`
            cursor: pointer
        `;

        const listItem = this.props.menus.map(data => {
            const content = data.translate ? <FormattedMessage {...messages[data.label]}/> : data.label,
                icon = data.icon ? <Icon className={data.icon}/> : '',
                linkTo = data.url ? data.url : '';
            return <ListItem key={data.key} value={linkTo} onClick={this.onClickHandler} style={{marginBottom: '10px'}}>
                {icon}
                {content}
            </ListItem>
        });

        return (<MenuWrapper>
            {listItem}
        </MenuWrapper>)
    }

}

MenuList.propTypes = {
    menus: PropTypes.array.isRequired
};

export default connect(null, {push})(MenuList);


// WEBPACK FOOTER //
// ./src/components/Footer/MenuList.js